﻿import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

Swiper.use([Pagination, Navigation]);

const swiperNavNextSelector = '.swiper-button-next';
const swiperNavPrevSelector = '.swiper-button-prev';
const swiperPaginationSelector = '.swiper-pagination';

const swiperConfig = {
    slidesPerView: 1.2,
    spaceBetween: 20,
    navigation: {
        nextEl: swiperNavNextSelector,
        prevEl: swiperNavPrevSelector,
    },
    pagination: {
        el: swiperPaginationSelector,
        type: 'fraction',
    },
    breakpoints: {
        768: {
            slidesPerView: 2.2,
            spaceBetween: 36,
        },
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const $logoSliders = document.querySelectorAll('.widget-logo-slider');

    $logoSliders.forEach($logoSlider => {
        new Swiper($logoSlider, {
            ...swiperConfig,
        });
    });

    const $basicSliders = document.querySelectorAll('.basic-slider');

    $basicSliders.forEach($slider => {
        new Swiper($slider, {
            ...swiperConfig,
        });
    });

    const $largeSliders = document.querySelectorAll('.large-slider');

    $largeSliders.forEach($slider => {
        new Swiper($slider, {
            ...swiperConfig,
            breakpoints: {
                768: {
                    slidesPerView: 1.2,
                    spaceBetween: 36,
                },
            }
        });
    });
});

export { swiperConfig };
